<td class="text-center">
  @if (collapsed) {
    <fa-icon class="text-secondary" [icon]="['fas', 'plus-square']" />
  }
  @if (!collapsed) {
    <fa-icon class="text-secondary" [icon]="['fas', 'minus-square']" />
  }
</td>
@if (forProvider) {
  <td><app-patient-name [patient]="prescription.patient" /></td>
}
<td>
  @if (prescription.drugs && prescription.drugs.length > 0) {
    @for (drug of prescription.drugs; track drug) {
      <div class="mb-1">
        <div>
          {{ drug.name }}
          <app-copy-to-clipboard [text]="drug.name" />
        </div>
        <div class="small">
          <strong>NDC:</strong> {{ drug.ndc }}
          <app-copy-to-clipboard [text]="drug.ndc" />
        </div>
      </div>
    }
  }
</td>
@if (!forProvider) {
  <td><app-prescriber-name [provider]="prescription.provider" /></td>
}
@if (!forProvider) {
  <td>
    <div>{{ prescription.provider.displaySpecialty }}</div>
  </td>
}
<td class="text-center">{{ prescription.writtenDate | date: 'MM/dd/yyyy' }}</td>
@if (showEstimatedValue) {
  <td class="text-center">{{ prescription.estimatedValue | currency }}</td>
}
<td>{{ prescription.sources && prescription.sources.join(', ') }}</td>
<td class="text-center">
  <span
    class="py-1 px-3 rounded borders"
    [ngClass]="{
      'highlight-high-value': prescription.needsEvidenceCapturesCount > 0 && prescription.highValue,
      'highlight-not-high-value': prescription.needsEvidenceCapturesCount > 0 && !prescription.highValue
    }"
    >
    {{ prescription.needsEvidenceCapturesCount }}
  </span>
</td>
<td class="text-center">
  <span
    class="py-1 px-3 rounded borders"
    [ngClass]="{
      'highlight-high-value': prescription.pendingCapturesCount > 0 && prescription.highValue,
      'highlight-not-high-value': prescription.pendingCapturesCount > 0 && !prescription.highValue
    }"
    >
    {{ prescription.pendingCapturesCount }}
  </span>
</td>
<td class="text-center">
  <span [ngClass]="{ 'py-1 px-3 rounded borders highlight-rejected': prescription.rejectedCapturesCount > 0 }">{{
    prescription.rejectedCapturesCount
  }}</span>
</td>
<td class="text-center">
  <span
    class="py-1 px-3 rounded borders"
    [ngClass]="{
      'highlight-high-value': prescription.ceReviewCapturesCount > 0 && prescription.highValue,
      'highlight-not-high-value': prescription.ceReviewCapturesCount > 0 && !prescription.highValue
    }"
    >
    {{ prescription.ceReviewCapturesCount }}
  </span>
</td>
<td class="text-center">{{ prescription.verifiedCapturesCount }}</td>
<td class="text-center">
  <span [ngClass]="{ 'py-1 px-3 rounded borders highlight-reversed': prescription.reversedCapturesCount > 0 }">{{
    prescription.reversedCapturesCount
  }}</span>
</td>
<td class="text-center">{{ prescription.otherCapturesCount }}</td>
<td class="text-center">{{ prescription.capturesCount }}</td>
